import React from 'react';
import PropTypes from 'prop-types';
import CallToAction from '../../atoms/CallToAction/CallToAction';
import './EmptyView.scss';

const EmptyView = ({
  message,
  action,
}) => (
  <div className="empty-view-container">
    <img src="/images/no-data.svg" alt="No data were found" />
    <span className="message">{message}</span>
    {action && (
      <CallToAction icon="plus" label="Try Adding an item" action={action} />
    )}
  </div>
);

EmptyView.propTypes = {
  message: PropTypes.string,
  action: PropTypes.func,
};

EmptyView.defaultProps = {
  message: undefined,
  action: undefined,
};

export default EmptyView;
